export default __webpack_public_path__ + "static/media/FotoDario.fcd76999.jfif";